module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "runners-list"
  }, _vm._l((_vm.runners), function(runner, index) {
    return _c('li', {
      key: index,
      staticClass: "runners-list__item"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "user-image"
    }), _vm._v(" "), _c('div', {
      staticClass: "user-infos"
    }, [_c('h1', {
      staticClass: "name"
    }, [_vm._v("\n           " + _vm._s(runner.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "more-infos"
    }, [_c('div', {
      staticClass: "flex flex--align-start"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("secondsToHours")(runner.time)))]), _vm._v(" "), _c('span', {
      staticClass: "separation"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(runner.pace ? runner.pace : "0'00\""))]), _vm._v(" "), _c('span', {
      staticClass: "separation"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("distance")(runner.distance)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_vm._v("\n        " + _vm._s(index + 1) + "\n      ")])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748ffe41"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TopThreeRunners.vue
// module id = 1728
// module chunks = 2